import { render, staticRenderFns } from "./SplitDetailForm.vue?vue&type=template&id=7e90ab88&scoped=true"
import script from "./SplitDetailForm.vue?vue&type=script&lang=js"
export * from "./SplitDetailForm.vue?vue&type=script&lang=js"
import style0 from "./SplitDetailForm.vue?vue&type=style&index=0&id=7e90ab88&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e90ab88",
  null
  
)

export default component.exports